import { render } from "./taskMark.vue?vue&type=template&id=6b63f8ac&scoped=true"
import script from "./taskMark.vue?vue&type=script&lang=js"
export * from "./taskMark.vue?vue&type=script&lang=js"

import "./taskMark.vue?vue&type=style&index=0&id=6b63f8ac&scoped=true&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b63f8ac"]])

export default __exports__